// extracted by mini-css-extract-plugin
module.exports = {"tabsBottomBoder":"ReportsTabs_tabsBottomBoder__3HIpC"};